// Petits mots sur le mur d'un autre membre. Miroir de const/wallNotes.js côté API : l'API reste la
// seule à décider (droit, quota, réglages du propriétaire) ; ces valeurs ne servent qu'à l'affichage.

// Longueur maximale d'un petit mot et de la réponse du destinataire (un émoji compte pour un).
export const WALL_NOTE_MAX_LENGTH = 300;

// Le compteur de caractères ne s'affiche qu'à l'approche de la limite.
export const WALL_NOTE_COUNTER_FROM = 250;

// Quota du jour par offre (affiché dans les textes des offres ; la valeur réelle vient de l'API).
export const WALL_NOTE_DAILY_LIMIT = {
    CERTIFIED: 1,
    PLUS: 5,
};

// Émojis proposés au clic dans le champ : ils s'ajoutent au texte, ils ne s'envoient pas seuls.
export const WALL_NOTE_SUGGESTED_EMOJIS = ['😘', '😉', '🔥', '😍', '👋'];

// Codes d'erreur renvoyés par l'API (errors.code).
export const WALL_NOTE_ERRORS = {
    NOT_ALLOWED: 'WALL_NOTE_NOT_ALLOWED',
    NO_RIGHT: 'WALL_NOTE_NO_RIGHT',
    DAILY_QUOTA_REACHED: 'WALL_NOTE_DAILY_QUOTA',
    INVALID_TEXT: 'WALL_NOTE_INVALID_TEXT',
};

// Filtre « Petits mots » du mur (petits mots à plat), cf. controllers/users.feed.js côté API.
export const WALL_NOTE_FEED_FILTER = 'WN';
